import React from 'react';
import DisplayRatePlanListItem from './DisplayRatePlanListItem';
import Error from '../../components/Error/Error';
import { hasValue } from '../../utils/helper_functions';

import style from './DisplayRatePlans.module.css';

function RatePlanList({ ratePlans, onDelete, action, product, forceRefresh }) {
  if (!hasValue(ratePlans)) {
    return (
      <Error
        heading="No Rate Plans available"
        message="Please add a new rate plan"
      />
    );
  }

  return (
    <div className={style.items}>
      {ratePlans.map(plan => (
        <DisplayRatePlanListItem
          key={plan.id}
          data={plan}
          action={action}
          onDelete={onDelete}
          product={product}
          forceRefresh={forceRefresh}
        />
      ))}
    </div>
  );
}

export default RatePlanList;
